// src/lib/formatters.js

// Normalize "03-04-1978", "3/4/78", "03 04 1978" → "1978-04-03"
export function normalizeDateToISO(input) {
  if (!input) return null;

  const cleaned = input
    .trim()
    .replace(/[.\s]/g, "-")
    .replace(/\//g, "-");

  const parts = cleaned.split("-").filter(Boolean);
  if (parts.length !== 3) return null;

  let [d, m, y] = parts;

  // Expand 2-digit year
  if (y.length === 2) {
    const yearNum = Number(y);
    if (Number.isNaN(yearNum)) return null;
    y = yearNum >= 50 ? `19${y}` : `20${y}`;
  }

  const day = String(Number(d)).padStart(2, "0");
  const month = String(Number(m) ).padStart(2, "0");
  const yearNum = Number(y);

  if (
    !yearNum ||
    Number.isNaN(yearNum) ||
    Number(month) < 1 ||
    Number(month) > 12 ||
    Number(day) < 1 ||
    Number(day) > 31
  ) {
    return null;
  }

  return `${y}-${month}-${day}`;
}

// Normalize "8:25 pm", "20:25", "0825", "8.25PM" → "HH:MM" (24h)
export function normalizeTimeTo24h(input) {
  if (!input) return null;

  let s = input.trim().toLowerCase().replace(/\s+/g, "");
  let isPM = s.includes("pm");
  let isAM = s.includes("am");
  s = s.replace(/am|pm/g, "");

  // Replace '.' with ':' => 8.25 -> 8:25
  s = s.replace(".", ":");

  // 3-4 digit numeric like "825" or "1225"
  if (/^\d{3,4}$/.test(s)) {
    const len = s.length;
    const mins = s.slice(len - 2);
    const hrs = s.slice(0, len - 2);
    s = `${hrs}:${mins}`;
  }

  const [hRaw, mRaw = "00"] = s.split(":");
  let h = Number(hRaw);
  const m = Number(mRaw);

  if (
    Number.isNaN(h) ||
    Number.isNaN(m) ||
    m < 0 ||
    m > 59 ||
    h < 0 ||
    h > 23
  ) {
    return null;
  }

  if (isPM && h < 12) h += 12;
  if (isAM && h === 12) h = 0;

  const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  return `${hh}:${mm}`;
}
